import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { useAppNavigate } from '@/hooks'
import SystemHeader from './SystemHeader'

interface SubMenuProps {
  groupId: string
  groupTitle: string
  items: Array<{ key: string; icon: string; title: string; desc: string }>
}

const SubMenu = ({ groupTitle, items }: SubMenuProps) => {
  const { t } = useTranslation('common')
  const navigate = useAppNavigate()

  return (
    <div className="min-h-screen bg-gray-100">
      <SystemHeader breadcrumbs={[{ label: groupTitle }]} />
      <main className="max-w-4xl mx-auto px-6 py-8">
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('home')}
          className="!px-0 !mb-4 !text-gray-600 hover:!text-blue-600"
        >
          戻る
        </Button>
        <div className="bg-white rounded-xl shadow-lg p-8">
          <Typography.Title level={3} className="!mb-1">
            {groupTitle}
          </Typography.Title>
          <Typography.Text type="secondary" className="block mb-8">
            {t('selectTask')}
          </Typography.Text>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {items.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => navigate(item.key)}
                className="group bg-gray-50 rounded-xl p-6 shadow-sm hover:shadow-md hover:bg-blue-50 transition-all duration-200 border border-gray-200 hover:border-blue-300 cursor-pointer text-left"
              >
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm group-hover:scale-110 transition-transform shrink-0">
                    <span className="text-2xl">{item.icon}</span>
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-gray-800 group-hover:text-blue-600 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-sm text-gray-500 group-hover:text-blue-500">{item.desc}</p>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </main>
    </div>
  )
}

export default SubMenu
